import { formatPhone } from 'utils/formatPhone';
import { ICallerCallItem } from '../types';
import { callerDisplayName } from '../mappers';
import {
  CardShell,
  CardBody,
  Content,
  CallLine,
  NameRow,
  NameText,
  Badge,
  Phone,
  Actions,
  SmsButton,
  BookButton,
  SkipButton,
} from './card-styles';
import incomingCallIcon from '../icons/incoming-call.svg';
import checkIcon from '../icons/check.svg';

type Props = {
  item: ICallerCallItem;
  onSms?: () => void;
  onBook?: () => void;
  onSkip?: () => void;
  pulse?: boolean; // true → latest call, shows the incoming-call pulse ring
};

// Incoming-call card: caller info on the left, SMS + BOOK + SKIP actions stacked
// on the right. Always expanded — no collapse toggle.
const CallerCard = ({ item, onSms, onBook, onSkip, pulse }: Props) => {
  return (
    <CardShell $pulse={pulse}>
      <CardBody>
        <Content>
          <CallLine>
            <img src={incomingCallIcon} alt="" />
            <span>{`Incoming call · ${item.callTimerText}`}</span>
          </CallLine>

          <NameRow>
            <NameText>{callerDisplayName(item)}</NameText>
            {item.nameAvailable && (
              <Badge>
                <img src={checkIcon} alt="" />
                name available
              </Badge>
            )}
          </NameRow>

          <Phone>{formatPhone(item.phone)}</Phone>
        </Content>

        <Actions>
          <SmsButton type="button" onClick={onSms}>
            SMS
          </SmsButton>
          <BookButton type="button" onClick={onBook}>
            BOOK
          </BookButton>
          <SkipButton type="button" onClick={onSkip}>
            SKIP
          </SkipButton>
        </Actions>
      </CardBody>
    </CardShell>
  );
};

export default CallerCard;
